import React from 'react'
import SignIn from '../Components/signup_signin/SignIn'

function LoginPage() {
  return (
    <SignIn/>
  )
}

export default LoginPage